module.exports = __webpack_public_path__ + "img/9-3.7a7ce652.png";